<template>
  <v-card height="100%" v-once>
    <v-card-title primary-title>
      <div class="headline">{{labels.applicant}}</div>
    </v-card-title>
    <v-card-text>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12>
            <v-subheader class="queryLabel">{{labels.appIntStat}}</v-subheader>
            <div>{{applicantStatus}}</div>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-if="applicant.appIntStat === 'E'">
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.coyName}}</v-subheader>
            <div>{{applicant.coyName}}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.coyRocUen}}</v-subheader>
            <div>{{applicant.coyRocUen}}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.coyNature}}</v-subheader>
            <div>{{applicant.coyNature}}</div>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-else>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.appSalutation}}</v-subheader>
            <div>{{salutation}}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.appName}}</v-subheader>
            <div v-if="applicant.appName">{{applicant.appName}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.appNricPassport}}</v-subheader>
            <div v-if="applicant.appNricPassport">{{applicant.appNricPassport}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.appDob}}</v-subheader>
            <div v-if="applicant.appDob">{{formatDisplayDate(applicant.appDob)}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.appGender}}</v-subheader>
            <div>{{gender}}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.appIsStudent}}</v-subheader>
            <div v-if="applicant.appIsStudent !== undefined">
              {{applicant.appIsStudent ? 'Yes':'No'}}
            </div>
            <div v-else>-</div>
          </v-flex>
          <!-- <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.appIsInsured}}</v-subheader>
            <div v-if="applicant.appIsInsured !== undefined">
              {{applicant.appIsInsured ? 'Yes':'No'}}
            </div>
            <div v-else>-</div>
          </v-flex> -->
        </v-layout>
      </v-container>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-title>
      <div class="body-2">{{labels.appContact}}</div>
    </v-card-title>
    <v-card-text>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.appEmail}}</v-subheader>
            <div v-if="applicant.appEmail">{{applicant.appEmail}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.appMobileNo}}</v-subheader>
            <div v-if="applicant.appMobileNo">{{applicant.appMobileNo}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.appTelNo1}}</v-subheader>
            <div v-if="applicant.appTelNo1">{{applicant.appTelNo1}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.appTelNo2}}</v-subheader>
            <div v-if="applicant.appTelNo2">{{applicant.appTelNo2}}</div>
            <div v-else>-</div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-title>
      <div class="body-2">{{labels.appAddress}}</div>
    </v-card-title>
    <v-card-text>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12>
            <div v-if="applicant.appPostalCode">
              {{applicant.appAdd1}} {{applicant.appAdd2}} <span v-if="applicant.appAdd3">#{{applicant.appAdd3}}</span> {{applicant.appAdd4}}, Singapore {{applicant.appPostalCode}}
            </div>
            <div v-else>-</div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-title>
      <div class="body-2">{{labels.mailAddress}}</div>
    </v-card-title>
    <v-card-text>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12>
            <div v-if="applicant.mailPostalCode">
              {{applicant.mailAdd1}} {{applicant.mailAdd2}} <span v-if="applicant.mailAdd3">#{{applicant.mailAdd3}}</span> {{applicant.mailAdd4}}, Singapore {{applicant.mailPostalCode}}
            </div>
            <div v-else>-</div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { formatDisplayDate } from '@/utils/date'
import { salutation, gender, applicantStatus } from '@/const/underwriting'
export default {
  data() {
    return {
      labels: {
        applicant: 'Applicant',
        appIntStat: 'Applicant Status',
        appName: 'Name as in NRIC/Passport',
        appSalutation: 'Salutation',
        appNricPassport: 'NRIC/Passport',
        appDob: 'Date of Birth',
        appGender: 'Gender',
        appIsInsured: 'Is Insured?',
        appIsStudent: 'Is full time student?',
        appAddress: 'Applicant Address',
        mailAddress: 'Mailing Address',
        appContact: 'Contacts',
        appEmail: 'Email',
        appMobileNo: 'Mobile No.',
        appTelNo1: 'Home No.',
        appTelNo2: 'Office No',
        coyName: 'Name of Company',
        coyRocUen: 'ROC/UEN',
        coyNature: 'Nature of Business'
      }
    }
  },
  computed: {
    applicant() {
      return this.$store.state.agency.quotation.commonForm.applicant
    },
    applicantStatus() {
      if (this.applicant.appIntStat) {
        return applicantStatus[this.applicant.appIntStat]
      } else {
        return ' - '
      }
    },
    salutation() {
      if (this.applicant.appSalutation) {
        return salutation[this.applicant.appSalutation]
      } else {
        return ' - '
      }
    },
    gender() {
      if (this.applicant.appGender) {
        return gender[this.applicant.appGender]
      } else {
        return ' - '
      }
    }
  },
  methods: {
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    }
  }
}
</script>

<style>
</style>
